interface Event {
    headline: string;
    sub_headline: string;
    description: string;
    starts_at: string;
    ends_at: string;
    display_date: string;
    location: string;
    primary_image: string;
    background_image: string;
    created_by: string;
    edited_by: string;
}

interface EventResponse {
    data: Event;
}

export default function eventDetail() {
    return {
        event: null as Event | null,
        eventName: "",
        isLoading: false,
        error: "",

        async init() {
            this.isLoading = true;
            this.error = "";

            try {
                const params = new URLSearchParams(window.location.search);
                const eventId = params.get("event_id");

                if (!eventId) {
                    throw new Error("No event ID provided");
                }

                const response = await fetch(`https://selig.sincore.com/api/v1/events/${eventId}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error(`Server error: ${response.status}`);
                }

                const data = (await response.json()) as EventResponse;
                this.event = data.data;

                // Set eventName combining headline and sub_headline
                this.eventName = this.event.sub_headline
                    ? `${this.event.headline} — ${this.event.sub_headline}`
                    : this.event.headline;

                // Dispatch custom event for form to listen to
                window.dispatchEvent(
                    new CustomEvent("event-loaded", {
                        detail: { eventName: this.eventName },
                    }),
                );
            } catch (error) {
                this.error = error instanceof Error ? error.message : "Failed to fetch event";
                console.error("Event detail fetch error:", error);
            } finally {
                this.isLoading = false;
            }
        },

        formatDate(dateString: string): string {
            if (!dateString) return "";
            const date = new Date(dateString.replace(/Z|[+-]\d{2}:\d{2}$/, ""));
            return new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
                timeZone: "America/New_York",
            }).format(date);
        },
    };
}
